import React, { forwardRef } from "react";
import { ToolbarButton } from "@wordpress/components";

// Unforwarded version
const UnforwardedCustomToolbarButton = ({ selected, label, icon, ...props },ref) => {
  return (
    <ToolbarButton
	  ref={ref}
      key={label}
      className={
        selected
          ? "image-hub-custom-toolbar-button-selected"
          : "image-hub-custom-toolbar-button"
      }
      variant="text"
      {...props}
    >
      {icon ? (
        <img
          height={16}
          width={16}
          style={{ marginRight: ".5em" }}
          src={icon}
          alt=""
        />
      ) : null}
      {label}
    </ToolbarButton>
  );
};

// Export forwarded version using the unforwarded component
export const CustomToolbarButton = forwardRef(UnforwardedCustomToolbarButton);